import Vue from 'vue'
import Dkfilter from './Dkfilter.vue'
// import './../../../../_2017/dk/www/public_html/t/dk/css/build.min.css'
// import './../dist/style.css'

import Transitions from 'vue2-transitions'
// Vue.config.productionTip = false
Vue.use(Transitions)

import PortalVue from 'portal-vue'
Vue.use(PortalVue)

import VueBrowserstore from 'vue-browserstore'
Vue.use(VueBrowserstore)

import Tooltip from 'vue-directive-tooltip';
// import 'vue-directive-tooltip/css/index.css';
Vue.use(Tooltip);


// import vMediaQuery from 'v-media-query'
// Vue.use(vMediaQuery)

if(document.getElementById("dkfilter")){
  setTimeout(() => {
    new Vue({
      el: '#dkfilter',
      render: h => h(Dkfilter)
    })
  }, (_GD.dkf.delay || 0) );
}


// WEBPACK FOOTER //
// ./src/main.js